import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import db from "../../firebase";  
import { useCollectionData } from "react-firebase-hooks/firestore";
import Grid from "@material-ui/core/Grid"
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

const AuthorPreview = (props) => {
    const authorsRef = db.collection("authors");
    const AuthorsQuery = authorsRef.where("name", "==", props.name);
    const [author] = useCollectionData(AuthorsQuery);
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        window.addEventListener("resize", () => (setWidth(window.innerWidth)));
    });
    // Mobile version
    if(width<500) {
        return (
            <section className="row m-0" id="portfolio">
                <Grid container direction="column">
                    {/* Name, face and social links */}
                    <Grid item container direction="row">
                        {/* Face */}
                        <Grid item xs={4}>
                            <Link to={author ? `/authors/${author[0].name}` : ""}><img className="postDp" id="portfolioPreviewDp" src={author && author[0].dpSrc} alt="" /></Link>
                        </Grid>
                        {/* Name and social links */}
                        <Grid item container direction="column" xs={8}>
                            {/* Name */}
                            <Grid item style={{textAlign: "center"}}>
                                <h2>{author && author[0].name}</h2>
                            </Grid>
                            {/* Social Links */}
                            <Grid item style={{textAlign: "center"}}>
                                {author && author[0].socialLinks.map((socialLink, i) => (
                                    <Link key={i} to={{ pathname: socialLink.url }} target="_blank" style={{padding: "2px"}}>
                                        {(socialLink.type === "twitter") && <TwitterIcon />}
                                        {(socialLink.type === "linkedIn") && <LinkedInIcon />}
                                    </Link>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* Description */}
                    <Grid item container direction="column">
                        {/* Designation */}
                        <Grid>
                            <b>{author && author[0].designation} at {author && author[0].institution}</b>                            
                        </Grid>
                        {/* Demo of the article */}
                        <Grid>
                            <p>Tahir Reyaz is an Electronics and Communications Engineering student at Jamia Millia Islamia, New Delhi, India.
                                He is also interested in coding stuff like Web Development...<Link to={`/authors/${author && author[0].name}`}>[Read full Bio]</Link>
                            </p>
                        </Grid>
                    </Grid>
                </Grid>
            </section>
        );
    } else {
        return(
            <section className="row m-0" id="portfolio">
                {/* Face and social links */}
                <div className="col-2 p-0 faceAndSocialLinks">
                    <div className="container p-0" style={{textAlign: "center"}}>
                        {/* Author's Face */}
                        <div className="row">
                            <Link to={author ? `/authors/${author[0].name}` : ""}><img className="postDp" id="portfolioPreviewDp" src={author && author[0].dpSrc} alt="" /></Link>
                        </div>
                        {/* Author's social links */}
                        <div className="row" style={{display: "inline"}}>
                            {author && author[0].socialLinks.map((socialLink, i) => (
                                <Link key={i} to={{ pathname: socialLink.url }} target="_blank" style={{padding: "2px"}}>
                                    {(socialLink.type === "twitter") && <TwitterIcon />}
                                    {(socialLink.type === "linkedIn") && <LinkedInIcon />}
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
                {/* Demo of the portfolio */}
                <div className="col">
                    <div className="container p-0">
                        {/* Name */}
                        <div className="row">
                            <h2>{author && author[0].name}</h2>
                        </div>
                        {/* Designation */}
                        <div className="row">
                            <b>{author && author[0].designation} at {author && author[0].institution}</b>
                        </div>
                        {/* Demo of the article */}
                        <div className="row">
                            <p>Tahir Reyaz is an Electronics and Communications Engineering student at Jamia Millia Islamia, New Delhi, India.
                                He is also interested in coding stuff like Web Development...<Link to={`/authors/${author && author[0].name}`}>[Read full Bio]</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default AuthorPreview;